import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      ["str", "int", "float"].indexOf(_vm.element.type) != -1
        ? _c(VTextField, {
            attrs: {
              outlined: _vm.edit,
              filled: !_vm.edit,
              "hide-details": "auto",
              dense: "",
              value: _vm.value,
            },
            model: {
              value: _vm.model,
              callback: function ($$v) {
                _vm.model = $$v
              },
              expression: "model",
            },
          })
        : _vm._e(),
      ["boolean"].indexOf(_vm.element.type) != -1
        ? _c(VCheckbox, {
            attrs: { "hide-details": "auto", dense: "", value: _vm.value },
            model: {
              value: _vm.model,
              callback: function ($$v) {
                _vm.model = $$v
              },
              expression: "model",
            },
          })
        : _vm._e(),
      ["typing.List", "typing.Dict"].indexOf(_vm.element.type) != -1
        ? _c(VTextarea, {
            attrs: {
              outlined: _vm.edit,
              filled: !_vm.edit,
              "hide-details": "auto",
              dense: "",
              value: _vm.value,
            },
            model: {
              value: _vm.model,
              callback: function ($$v) {
                _vm.model = $$v
              },
              expression: "model",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }